<script setup lang="ts">
import { Loader2, StopCircle } from 'lucide-vue-next';
import { ref } from 'vue';
import { cancel as runCancel } from '@/actions/App/Http/Controllers/RunController';
import { Button } from '@/components/ui/button';

const props = defineProps<{
    activityId: string;
}>();

const emit = defineEmits<{
    interrupted: [];
}>();

const loading = ref(false);

async function interrupt() {
    if (loading.value) {
        return;
    }

    const confirmed = window.confirm(
        'Interrompre cette activité ? Elle ne pourra pas être reprise.',
    );

    if (!confirmed) {
        return;
    }

    loading.value = true;

    try {
        const res = await fetch(runCancel(props.activityId).url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (res.ok) {
            emit('interrupted');
        }
    } finally {
        loading.value = false;
    }
}
</script>

<template>
    <Button
        variant="outline"
        size="sm"
        :disabled="loading"
        aria-label="Interrompre l'activité"
        @click="interrupt"
    >
        <Loader2 v-if="loading" class="mr-1.5 h-3.5 w-3.5 animate-spin" />
        <StopCircle v-else class="mr-1.5 h-3.5 w-3.5" />
        Interrompre
    </Button>
</template>
